"use strict";
// outils\rules.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.rulePrixPositif = void 0;
function rulePrixPositif(value) {
    return value == null || value == "" || value >= 0;
}
exports.rulePrixPositif = rulePrixPositif;
